import styled from '@emotion/styled';
import { Button as _Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Help from '@material-ui/icons/Help';
import Settings from '@material-ui/icons/Settings';
import { ClassAttributes, Component, createElement, MouseEvent, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

import { UserOptimizer } from '../../../../graphql/generated/graphql';
import { SPACING_LARGE, SPACING_UNIT } from '../../../constant/spacing';
import AvatarWithName from '../../primitive/AvatarWithName';
import { Globe } from '../../primitive/Icons';

interface Props {
  signedInUser: UserOptimizer;
  onClickSettings: MouseEventHandler<HTMLElement>;
  onClickSignOut: MouseEventHandler<HTMLElement>;
  onClickAccountSettings: MouseEventHandler<HTMLElement>;
  profileWebUrl: string;
  className?: string;
}

interface State {
  open: boolean;
  anchorEl: HTMLElement | undefined;
}

const initialState = {
  open: false,
  anchorEl: undefined,
};

class UserMenu extends Component<ClassAttributes<HTMLElement> & Props, State> {
  state = initialState;

  render() {
    const { signedInUser, className, profileWebUrl } = this.props;

    return (
      <Root className={className}>
        <Button size="small" onClick={this.onClickMenu}>
          <AvatarWithName
            imageUrl={signedInUser.profileImageUrl}
            name={signedInUser.name || ''}
            aria-owns={this.state.open ? 'menu-appbar' : null}
            aria-haspopup="true"
          />
        </Button>

        <StyledMenu
          id="menu-appbar"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.open}
          onClose={this.onRequestClose}
        >
          <MenuItem button onClick={this.onClickSettings}>
            <ListItemIcon>
              <Globe />
            </ListItemIcon>

            <ListItemText primary={<FormattedMessage id="headbar.settings" />} />
          </MenuItem>

          <MenuItem button component="a" href={profileWebUrl} target="_blank" rel="noopener noreferrer">
            <ListItemIcon>
              <AccountCircle />
            </ListItemIcon>
            <ListItemText primary={<FormattedMessage id="headbar.profile" />} />
          </MenuItem>

          <MenuItem button onClick={this.onClickAccountSettings}>
            <ListItemIcon>
              <Settings />
            </ListItemIcon>

            <ListItemText primary={<FormattedMessage id="headbar.account_settings" />} />
          </MenuItem>

          <MenuItem button component="a" href="https://help.kaizen-ad.com/" target="_blank" rel="noopener noreferrer">
            <ListItemIcon>
              <Help />
            </ListItemIcon>

            <ListItemText primary={<FormattedMessage id="headbar.help" />} />
          </MenuItem>

          <MenuItem button onClick={this.onClickSignOut}>
            <ListItemIcon>
              <ExitToApp />
            </ListItemIcon>

            <ListItemText primary={<FormattedMessage id="headbar.sign_out" />} />
          </MenuItem>
        </StyledMenu>
      </Root>
    );
  }

  private onClickMenu = (e: MouseEvent<HTMLElement>) => {
    this.setState({ open: true, anchorEl: e.currentTarget });
  };

  private onRequestClose = () => {
    this.setState({ open: false });
  };

  private onClickSettings = (e: MouseEvent<HTMLElement>) => {
    this.props.onClickSettings(e);
    this.setState({ open: false });
  };

  private onClickAccountSettings = (e: MouseEvent<HTMLElement>) => {
    this.props.onClickAccountSettings(e);
    this.setState({ open: false });
  };

  private onClickSignOut = (e: MouseEvent<HTMLElement>) => {
    this.props.onClickSignOut(e);
    this.setState({ open: false });
  };
}

const Root = styled('div')();

const Button = styled(_Button)({
  padding: SPACING_UNIT / 2,
  textTransform: 'none',
});

const StyledMenu = styled(Menu)({
  marginTop: SPACING_LARGE,
});

export default UserMenu;
